<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card no-margin-bottom">
          <div class="card-block">
            <ui-data-table
              id="marketplaces-list"
              ref="list"
              :columns="columns"
              :filters="filters"
              :endpoint="endpoint"
              size="sm"
            >
              <template
                slot="name"
                slot-scope="row"
              >
                <a
                  href="#"
                  @click.prevent="click(row)"
                >{{ row.title }}</a>
              </template>

              <template
                slot="language_id"
                slot-scope="row"
              >
                {{ row.language.name }}
              </template>

              <template
                slot="credentials_fields"
                slot-scope="row"
              >
                <template v-if="row['credentials_fields'] === null">
                  0
                </template>
                <template v-else>
                  {{ Object.keys(row['credentials_fields']).length }}
                </template>
              </template>

              <template
                slot="fields"
                slot-scope="row"
              >
                <template v-if="row['fields'] === null">
                  0
                </template>
                <template v-else>
                  {{ Object.keys(row['fields']).length }}
                </template>
              </template>

              <template
                slot="templates"
                slot-scope="row"
              >
                <template v-if="row['templates'] === null">
                  0
                </template>
                <template v-else>
                  {{ Object.keys(row['templates']).length }}
                </template>
              </template>
            </ui-data-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '../services/ApiService';

export default {
  name: 'AppPageMarketplaces',
  data() {
    return {
      columns: [
        {
          name: 'ID',
          key: 'id',
          sorting: true,
          styles: 'text-right',
        },
        {
          name: this.$t('Name'),
          key: 'name',
          sorting: true,
        },
        {
          name: this.$t('Title'),
          key: 'title',
          sorting: true,
        },
        {
          name: this.$tc('Languages', 1),
          key: 'language_id',
          sorting: true,
        },
        {
          name: this.$tc('Credential Fields', 2),
          key: 'credentials_fields',
          styles: 'text-right',
        },
        {
          name: this.$tc('Fields', 2),
          key: 'fields',
          styles: 'text-right',
        },
        {
          name: this.$tc('Categories', 2),
          key: 'categories_count',
          styles: 'text-right',
        },
        {
          name: this.$tc('Templates', 2),
          key: 'templates',
          styles: 'text-right',
        },
      ],
      filters: [
        {
          name: 'ID',
          key: 'id',
          type: 'integer',
        },
        {
          name: this.$t('Name'),
          key: 'name',
          type: 'string',
        },
        {
          name: this.$t('Title'),
          key: 'title',
          type: 'string',
        },
      ],
      endpoint: `${ApiService.getLink('marketplaces')}&includes=language`,
    };
  },
  methods: {
    click(marketplace) {
      this.saveCurrentAndGo('marketplaces', { name: 'MarketplaceMain', params: { marketplaceId: marketplace.id } });
    },
  },
};
</script>
